<div class="dialog-header">
    <h2 mat-dialog-title>{{data.title}}{{data.nomeArquivo && data.imagemMinio ? ' - (' + data.nomeArquivo + ')' :
        ''}}
    </h2>
</div>

<mat-dialog-content>
    <div class="content-container">
        <div class="image-preview" *ngIf="imagemPreview || data.imagemMinio">
            <img [src]="imagemPreview || data.imagemMinio" alt="Preview">
        </div>
        <div class="upload-area" *ngIf="!data.isVisualizacao && !imagemPreview && !data.imagemMinio"
            (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
            (dragenter)="onDragOver($event)" [class.drag-over]="isDragging" tabindex="0">
            <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" style="display: none;">
            <mat-icon class="upload-icon">cloud_upload</mat-icon>
            <p class="upload-text">Arraste uma imagem aqui, cole (Ctrl+V) ou clique para selecionar</p>
            <button mat-raised-button color="primary" class="upload-button" (click)="fileInput.click()">
                <mat-icon>upload</mat-icon>
                Selecionar Imagem
            </button>
            <span class="selected-file" *ngIf="imagemSelecionada">
                {{imagemSelecionada.name}}
            </span>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="actions-container">
        <div class="left-actions">
            <button mat-raised-button color="primary" class="action-button"
                *ngIf="data.isVisualizacao && (data.imagemMinio || imagemPreview)" (click)="onDownload()">
                <mat-icon>download</mat-icon>
                <span>Download</span>
            </button>
            <button mat-raised-button color="primary" class="action-button" *ngIf="!data.isVisualizacao"
                [disabled]="!imagemSelecionada" (click)="onAnexar()">
                <mat-icon>save</mat-icon>
                <span>Salvar</span>
            </button>
            <button mat-raised-button color="primary" class="action-button"
                *ngIf="data.isVisualizacao && (data.imagemMinio || imagemPreview)" (click)="onAbrirNovaAba()">
                <mat-icon>open_in_new</mat-icon>
                <span>Abrir</span>
            </button>
            <button mat-raised-button color="warn" class="action-button delete-button"
                *ngIf="data.isVisualizacao && (data.imagemMinio || imagemPreview)" (click)="onDelete()">
                <mat-icon>delete</mat-icon>
                <span>Excluir</span>
            </button>
        </div>
        <div class="right-actions">
            <button mat-stroked-button color="primary" class="cancel-button" (click)="onCancel()">
                <mat-icon>close</mat-icon>
                <span>Fechar</span>
            </button>
        </div>
    </div>
</mat-dialog-actions>
